'use strict';

module.exports = {
    'AOA': 'Kz',
    'ARS': '$',
    'AUD': '$',
    'BAM': 'KM',
    'BBD': '$',
    'BDT': '৳',
    'BMD': '$',
    'BND': '$',
    'BOB': 'Bs',
    'BRL': 'R$',
    'BSD': '$',
    'BWP': 'P',
    'BYN': 'р.',
    'BZD': '$',
    'CAD': '$',
    'CLP': '$',
    'CNY': '¥',
    'COP': '$',
    'CRC': '₡',
    'CUC': '$',
    'CUP': '$',
    'CZK': 'Kč',
    'DKK': 'kr',
    'DOP': '$',
    'EGP': 'E£',
    'ESP': '₧',
    'EUR': '€',
    'FJD': '$',
    'FKP': '£',
    'GBP': '£',
    'GEL': '₾',
    'GIP': '£',
    'GNF': 'FG',
    'GTQ': 'Q',
    'GYD': '$',
    'HKD': '$',
    'HNL': 'L',
    'HRK': 'kn',
    'HUF': 'Ft',
    'IDR': 'Rp',
    'ILS': '₪',
    'INR': '₹',
    'ISK': 'kr',
    'JMD': '$',
    'JPY': '¥',
    'KHR': '៛',
    'KMF': 'CF',
    'KPW': '₩',
    'KRW': '₩',
    'KYD': '$',
    'KZT': '₸',
    'LAK': '₭',
    'LBP': 'L£',
    'LKR': 'Rs',
    'LRD': '$',
    'LTL': 'Lt',
    'LVL': 'Ls',
    'MGA': 'Ar',
    'MMK': 'K',
    'MNT': '₮',
    'MUR': 'Rs',
    'MXN': '$',
    'MYR': 'RM',
    'NAD': '$',
    'NGN': '₦',
    'NIO': 'C$',
    'NOK': 'kr',
    'NPR': 'Rs',
    'NZD': '$',
    'PHP': '₱',
    'PKR': 'Rs',
    'PLN': 'zł',
    'PYG': '₲',
    'RON': 'lei',
    'RUB': '₽',
    'RUR': 'р.',
    'RWF': 'RF',
    'SBD': '$',
    'SEK': 'kr',
    'SGD': '$',
    'SHP': '£',
    'SRD': '$',
    'SSP': '£',
    'STN': 'Db',
    'SYP': '£',
    'THB': '฿',
    'TOP': 'T$',
    'TRY': '₺',
    'TTD': '$',
    'TWD': '$',
    'UAH': '₴',
    'USD': '$',
    'UYU': '$',
    'VEF': 'Bs',
    'VND': '₫',
    'XCD': '$',
    'ZAR': 'R',
    'ZMW': 'ZK'
};
